module.exports = __webpack_public_path__ + "img/receive-yield.c1ba38fa.png";